import React, { useMemo } from 'react';
import { AgGridReact } from 'ag-grid-react';
import { StyCadrageAgContainer } from '../style';
import { BudgetProposalWithResourcesT } from 'routes/BudgetModule/config/types';
import { getCustomCadrageColDefs } from './helper';
import ActionsCellRenderer from './ActionsCellRenderer';
import ToggleCellRenderer from './ToggleCellRenderer';

const DEFAULT_COL_DEF = {
    flex: 1,
    suppressHeaderMenuButton: true,
};

const CustomCadrageGrid = ({
    budgetProposals = [],
    exercice,
}: {
    budgetProposals?: BudgetProposalWithResourcesT[];
    exercice: number;
}): React.ReactElement => {
    const filteredBudgetProposals = useMemo(
        () =>
            budgetProposals.filter(
                (budgetProposal) => budgetProposal.exercice === exercice,
            ),
        [budgetProposals, exercice],
    );

    return (
        <StyCadrageAgContainer
            className="ag-theme-material"
            data-testid="e2e-custom-cadrage-grid"
        >
            <AgGridReact
                columnDefs={getCustomCadrageColDefs()}
                rowData={filteredBudgetProposals}
                defaultColDef={DEFAULT_COL_DEF}
                components={{
                    toggleCellRenderer: ToggleCellRenderer,
                    actionsCellRenderer: ActionsCellRenderer,
                }}
            />
        </StyCadrageAgContainer>
    );
};

export default CustomCadrageGrid;
